const LS_ZAPI_CHAT_HISTORY_STORAGE = "zapi-chat-history-storage" as const;
const LS_CREATE_PROJECT_STORAGE = "create-project-storage" as const;
const LS_ORGANIZATION_STORAGE = "organization-storage" as const;
const LS_DIFF_STORAGE = "zapi-diff-storage" as const;
const LS_CHAT_ASK_STORAGE = "chat-ask-storage" as const;
const LS_CASE_BRIEF_CHAT_STORAGE = "case-brief-chat-storage" as const;
const LS_MEMO_VIEW_STORAGE = "memo-view-storage" as const;
const LS_PORTFOLIO_PREFS_STORAGE = "portfolio-prefs-storage" as const;
const LS_PROJECTS_LIST_CHAT_STORAGE = "projects-list-chat-storage" as const;
const LS_LEO_DOCK_HIDDEN = "leo-dock-hidden" as const;

const LOCAL_STORAGE_KEYS = [
  LS_ZAPI_CHAT_HISTORY_STORAGE,
  LS_CREATE_PROJECT_STORAGE,
  LS_ORGANIZATION_STORAGE,
  LS_DIFF_STORAGE,
  LS_CHAT_ASK_STORAGE,
  LS_CASE_BRIEF_CHAT_STORAGE,
  LS_MEMO_VIEW_STORAGE,
  LS_PORTFOLIO_PREFS_STORAGE,
  LS_PROJECTS_LIST_CHAT_STORAGE,
  LS_LEO_DOCK_HIDDEN
] as const;

export {
  LOCAL_STORAGE_KEYS,
  LS_ZAPI_CHAT_HISTORY_STORAGE,
  LS_CREATE_PROJECT_STORAGE,
  LS_ORGANIZATION_STORAGE,
  LS_DIFF_STORAGE,
  LS_CHAT_ASK_STORAGE,
  LS_CASE_BRIEF_CHAT_STORAGE,
  LS_MEMO_VIEW_STORAGE,
  LS_PORTFOLIO_PREFS_STORAGE,
  LS_PROJECTS_LIST_CHAT_STORAGE,
  LS_LEO_DOCK_HIDDEN
};

export type TLocalStorageKey = (typeof LOCAL_STORAGE_KEYS)[number];
